import Typography from '@mui/material/Typography';
import MarkdownText from '~/components/MarkdownText';
import NAMES from '~/constants/NAMES';
import termsOfUse from '~/docs/termsOfUse.md';
const today = new Date();
const year = today.getFullYear();
export const TermsOfUse = (): JSX.Element => {
  return <>
      <MarkdownText data-sentry-element="MarkdownText" data-sentry-source-file="index.tsx">{termsOfUse.toString()}</MarkdownText>
      <Typography data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        ©{year} by {NAMES.COMPANY} All rights reserved.
      </Typography>
    </>;
};
export default TermsOfUse;